import type { SVGProps } from 'react';

const SvgLineLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={17}
    viewBox='0 0 16 17'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.58 7.253a1.58 1.58 0 1 0-3.16 0 1.58 1.58 0 0 0 3.16 0m1 0a2.58 2.58 0 1 1-5.16 0 2.58 2.58 0 0 1 5.16 0'
      fill='#3889FF'
    />
    <path
      d='M8.002 1.213c2.654.002 5.358 1.567 6.072 4.723l.069.342c.617 3.507-1.583 6.415-3.397 8.156a3.96 3.96 0 0 1-5.352.134l-.148-.134c-1.865-1.798-4.15-4.845-3.321-8.505l.073-.29c.814-2.962 3.433-4.427 6.004-4.426m0 1C5.795 2.212 3.635 3.453 2.96 5.91l-.06.24c-.705 3.114 1.223 5.813 3.037 7.562h.001a2.96 2.96 0 0 0 4.114.001l.342-.34c1.653-1.69 3.254-4.128 2.762-6.925l-.058-.291c-.593-2.617-2.82-3.942-5.097-3.944'
      fill='#3889FF'
    />
  </svg>
);
export default SvgLineLocation;
